export default __webpack_public_path__ + "static/media/spiral.823ba2e6.png";